import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useToast } from '@cmpsr/components';
import Questionnaire from './components/questionnaire/questionnaire';
import useQuestionnaireController from './questionnaire.controller';
import { Status } from './types';

export default function QuestionnairePage() {
  const toast = useToast();
  const { backOnFirstSurveyItem, status, uploadAnswers, userQuestionnaire } = useQuestionnaireController();

  if (status === Status.inProgress && userQuestionnaire) {
    return (
      <Questionnaire
        userQuestionnaire={userQuestionnaire}
        decisionTreeCallback={uploadAnswers}
        backOnFirstSurveyItem={backOnFirstSurveyItem}
      />
    );
  }

  if (status === Status.inProgress && !userQuestionnaire) {
    toast({
      ...TOAST_DEFAULT_OPTIONS,
      title: 'Error',
      description: 'Error connecting to the Catch server.',
      status: 'error',
    });
  }
}
